module.exports = __webpack_public_path__ + "img/402.dd66bb44.png";